import React from 'react'
import './Heading.css'

const Heading = ({ children, eyebrow }) => {
	return (
		<div className='heading-wrapper'>
			{eyebrow && <span className='eyebrow'>{eyebrow}</span>}
			<h2>{children}</h2>
		</div>
	)
}

export default Heading
